import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const authHeaders = (token) => ({ Authorization: `Bearer ${token}` });

// Public
export const submitQuote = (data) => api.post("/quotes", data).then((r) => r.data);
export const submitContact = (data) => api.post("/contact", data).then((r) => r.data);

// Auth
export const authLogin = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);
export const authMe = (token) =>
  api.get("/auth/me", { headers: authHeaders(token) }).then((r) => r.data);
export const changePassword = (current_password, new_password, token) =>
  api
    .post("/auth/change-password", { current_password, new_password }, { headers: authHeaders(token) })
    .then((r) => r.data);

// Quotes (leads)
export const fetchQuotes = (token) =>
  api.get("/quotes", { headers: authHeaders(token) }).then((r) => r.data);
export const fetchStats = (token) =>
  api.get("/quotes/stats", { headers: authHeaders(token) }).then((r) => r.data);
export const updateQuoteStatus = (id, status, token) =>
  api
    .patch(`/quotes/${id}?status=${status}`, {}, { headers: authHeaders(token) })
    .then((r) => r.data);
export const addQuoteNote = (id, text, token) =>
  api.post(`/quotes/${id}/notes`, { text }, { headers: authHeaders(token) }).then((r) => r.data);
export const deleteQuote = (id, token) =>
  api.delete(`/quotes/${id}`, { headers: authHeaders(token) }).then((r) => r.data);
export const createManualLead = (data, token) =>
  api.post(`/quotes/manual`, data, { headers: authHeaders(token) }).then((r) => r.data);

// Clients (book of business)
export const fetchClients = (token) =>
  api.get("/clients", { headers: authHeaders(token) }).then((r) => r.data);
export const createClient = (data, token) =>
  api.post(`/clients`, data, { headers: authHeaders(token) }).then((r) => r.data);
export const updateClientStatus = (id, status, token) =>
  api
    .patch(`/clients/${id}?status=${status}`, {}, { headers: authHeaders(token) })
    .then((r) => r.data);
export const addClientNote = (id, text, token) =>
  api.post(`/clients/${id}/notes`, { text }, { headers: authHeaders(token) }).then((r) => r.data);
export const deleteClient = (id, token) =>
  api.delete(`/clients/${id}`, { headers: authHeaders(token) }).then((r) => r.data);
